export class SubcategoryEditModel {
    public id: string;
    public name: string;
    public parentId: string;
    constructor() {
        this.parentId = '';
    }
}
